import React from "react";
import Card from "components/card";
import ProgramEmployeeCard from "./ProgramEmployeeCard";

const EmployeeListPanel = ({ employees, selectedEmployee, onSelect }) => {

    return (
        <Card className="flex flex-col gap-6 rounded-2xl border-2 shadow-sm bg-white lg:col-span-1 h-full">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 pb-6 bg-slate-50/50 border-b rounded-t-xl">
                <h4 className="text-[18px]">
                    Employees in Program
                </h4>
                <p className="text-[13px] text-slate-500">
                    Select to view detailed progress
                </p>
            </div>
            <div className="p-4 pb-6">
                <div className="space-y-3 max-h-[600px] overflow-y-auto">
                    {employees.map((emp) => (
                        <ProgramEmployeeCard
                            key={emp.employee_id}
                            initials={emp.initials}
                            name={emp.name}
                            role={emp.role}
                            employee_id={emp.employee_id}
                            progress={emp.overall_progress}
                            milestone={emp.milestone}
                            hours={emp.hours}
                            selected={selectedEmployee?.employee_id === emp.employee_id}
                            onClick={() => onSelect(emp)}
                        />
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default EmployeeListPanel;